import type { ComponentInternalInstance, InjectionKey, Ref } from 'vue';

export const parentInjectionKey = Symbol() as InjectionKey<ComponentInternalInstance>;
export const childItemsInjectionKey = Symbol() as InjectionKey<Ref<ComponentInternalInstance[]>>;
